import { useReducer } from 'react';

import { CONTACTINFO_VALIDATE } from '../../Hooks/useContactInfo';
import { useInput } from '../../Hooks/useInput';

import { isPG, PAY_DATA } from '../../lib/PaymentInfo';

const PRE_PURCHASE_INITIAL_STATE = {
  itemId: null,
  prePurchaseItemId: null,
  optionIds: [],
  prePurchaseOptionIds: [],
  defaultPrice: 0,
  finalShippingFee: 0,
  finalPrice: 0,
  email: '',
  name: '',
  mobile: '',
  voucherIds: [],
  pg: PAY_DATA.html5_inicis,
  pay_method: PAY_DATA.card,
};

const TYPE = {
  SET_PRE_PURCHASE_IDS: 'SET_PRE_PURCHASE_IDS',
  SET_TEMP_ORDER_INFO: 'SET_TEMP_ORDER_INFO',
  SET_USER_INFO: 'SET_USER_INFO',
  ON_PAYMENT_METHOD: 'ON_PAYMENT_METHOD',
};

function reducer(state, action) {
  switch (action.type) {
    case TYPE.SET_PRE_PURCHASE_IDS:
      return {
        ...state,
        prePurchaseItemId: action.id,
        prePurchaseOptionIds: action.optionIds,
      };
    case TYPE.SET_TEMP_ORDER_INFO:
      const {
        data: { defaultPrice, finalShippingFee, finalPrice },
        voucherIds,
      } = action;
      return {
        ...state,
        defaultPrice,
        finalShippingFee,
        finalPrice,
        voucherIds,
      };
    case TYPE.SET_USER_INFO:
      const { email, name, contactInfo } = action.data;
      return {
        ...state,
        email,
        name,
        mobile: contactInfo === null ? '' : contactInfo.mobile,
      };
    case TYPE.ON_PAYMENT_METHOD:
      const actionValue = action.target.value;
      return {
        ...state,
        pg: isPG(actionValue) ? actionValue : PRE_PURCHASE_INITIAL_STATE.pg,
        pay_method: isPG(actionValue) ? '' : actionValue,
      };
    default:
      throw new Error();
  }
}

export default function PrePurchaseReducer() {
  const [state, dispatch] = useReducer(reducer, PRE_PURCHASE_INITIAL_STATE);
  const { state: buyerInfo, onChangeValue, setValueAll } = useInput({
    initialState: {
      name: state.name,
      mobile: state.mobile,
      nameError: null,
      mobileError: null,
    },
    validate: CONTACTINFO_VALIDATE,
  });
  const setPrePurchaseIds = ({ id, optionIds }) => {
    dispatch({ type: TYPE.SET_PRE_PURCHASE_IDS, id, optionIds });
  };

  const setTempOrderInfo = ({ data, voucherIds }) => {
    dispatch({ type: TYPE.SET_TEMP_ORDER_INFO, data, voucherIds });
  };

  const setUserInfo = ({ data }) => {
    dispatch({ type: TYPE.SET_USER_INFO, data });
    setValueAll({
      object: {
        name: data.name,
        mobile: data.contactInfo === null ? '' : data.contactInfo.mobile,
      },
    });
  };

  const onPaymentMethod = (e) => {
    dispatch({ type: TYPE.ON_PAYMENT_METHOD, target: e.target });
  };

  return {
    state,
    setPrePurchaseIds,
    setTempOrderInfo,
    setUserInfo,
    onPaymentMethod,
    buyerInfo,
    onChangeValue,
  };
}
